export default __webpack_public_path__ + "static/media/infusion-pedia.feeab3df.jpg";